var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 15.078,
    width: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M15.668 11.541l-5.652-10.39a2.344 2.344 0 00-4.031 0L.333 11.541a2.343 2.343 0 002.015 3.54h11.3a2.343 2.343 0 002.02-3.54zM8 13.202a.938.938 0 11.938-.937.939.939 0 01-.938.937zm.938-3.75a.938.938 0 01-1.875 0V4.765a.938.938 0 011.875 0z"
  })));
}
export default __webpack_public_path__ + "media/icons/icn_alert-035b6e36.svg";
export { SvgIcnAlert as ReactComponent };